import React, { Component } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class UserProfile extends Component {
  state = {
    isLoading: false,
    nameFamily: "",
    mobile: this.props.mobileNumber,
    companyName: "",
    sematSazmani: "",
    email: "",
    website: "",
    address: "",
  };

  async componentDidMount() {
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    this.setState({ isLoading: true });
    const data = await fetch(`/ng/api/UserRegister/${p2e(this.state.mobile)}`);
    const res = await data.json();
    this.setState({
      isLoading: false,
      nameFamily: res.NameFamily === null ? "" : res.NameFamily,
      companyName: res.CompanyName === null ? "" : res.CompanyName,
      sematSazmani: res.Semat === null ? "" : res.Semat,
      email: res.Email === null ? "" : res.Email,
      website: res.Website === null ? "" : res.Website,
      address: res.Address === null ? "" : res.Address,
    });
  }
  onSubmit = async (e) => {
    e.preventDefault();
    const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    if (this.state.mokhatab === "" || this.state.sharh === "") {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    const userInfo = {
      Mobile: p2e(this.state.mobile),
      NameFamily: this.state.nameFamily,
      CompanyName:
        this.state.companyName === "" ? null : this.state.companyName,
      Semat: this.state.sematSazmani === "" ? null : this.state.sematSazmani,
      Email: this.state.email === "" ? null : this.state.email,
      Website: this.state.website === "" ? null : this.state.website,
      Address: this.state.address === "" ? null : this.state.address,
    };
    this.setState({ isLoading: true });
    const res = await fetch("/ng/api/UserRegister/" + p2e(this.state.mobile), {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userInfo),
    });
    const dataBack = await res.json();
    this.setState({ isLoading: false });
    if (dataBack.Result === "Ok") {
      alert("بروز رسانی اطلاعات کاربری با موفقیت انجام شد");
      this.props.handleProfileUpdate(this.state.nameFamily);
    } else {
      alert("پاسخی از سرور دریافت نشد");
    }
  };
  render() {
    const { isLoading } = this.state;
    return (
      <Stack
        component="form"
        spacing={1.5}
        noValidate
        autoComplete="off"
        onSubmit={this.onSubmit}
      >
        <LoadingCircular open={isLoading} />
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          پروفایل کاربری
        </Typography>
        <TextField
          disabled
          label="شماره همراه"
          value={this.state.mobile}
          variant="standard"
        />
        <TextField
          required
          label="نام و نام خانوادگی"
          value={this.state.nameFamily}
          variant="standard"
          onChange={(e) => {
            this.setState({ nameFamily: e.target.value });
          }}
        />
        <TextField
          label="نام شرکت"
          value={this.state.companyName}
          variant="standard"
          onChange={(e) => {
            this.setState({ companyName: e.target.value });
          }}
        />
        <TextField
          label="سمت سازمانی"
          value={this.state.sematSazmani}
          variant="standard"
          onChange={(e) => {
            this.setState({ sematSazmani: e.target.value });
          }}
        />
        <TextField
          type="email"
          label="ایمیل"
          value={this.state.email}
          variant="standard"
          onChange={(e) => {
            this.setState({ email: e.target.value });
          }}
        />
        <TextField
          label="وبسایت"
          value={this.state.website}
          variant="standard"
          onChange={(e) => {
            this.setState({ website: e.target.value });
          }}
        />
        <TextField
          multiline
          label="آدرس"
          value={this.state.address}
          variant="standard"
          onChange={(e) => {
            this.setState({ address: e.target.value });
          }}
        />
        <Button type="submit" variant="contained">
          ذخیره
        </Button>
      </Stack>
    );
  }
}

export default UserProfile;
